import React from "react";
import { MediasLibrary } from "../../components/MediasLibrary/MediasLibrary";
import "./style.scss";
const Main = (view) => {
    return (React.createElement(MediasLibrary, { standalone: true }));
};
export default Main;
